import React, { Component } from "react";
import FormGroup from "../shared/form/FormGroup";
import Store from "../../content/Store";
import FormGroupMfa from "./form/FormGroupMfa";

export class PersonConsent extends Component {
  updateConsent(change) {
    var consent = Object.assign(this.props.PersonConsent, change);
    this.props.updateConsent(consent);
  }

  render() {
    return [
      Store.PersonConsent.TypeEmail,
      Store.PersonConsent.TypePhone,
      Store.PersonConsent.TypePost,
      Store.PersonConsent.TypeSms
    ].map(informMethod => {
    
    
    
      return (

        window?.axa?.features?.MFAFeature === "true"?
        <FormGroupMfa
          className={"form-group mt-0 mfapadding"}
          type="yesno"
          id={"inform" + informMethod}
          label={informMethod === "Sms" ? "Text" : (informMethod === "Telephone"? "Phone call":informMethod)}
          key={informMethod}
          currentValue={this.props.PersonConsent[informMethod]}
          onChange={event =>
            this.updateConsent({
              [informMethod]:
                event.target.value === "true"
                  ? true
                  : event.target.value === "false"
                  ? false
                  : null
            })
          }
          Zebrafied={this.props.Zebrafied}
          UseSlider={this.props.UseSlider}
        />
        :
                <FormGroup
          className={"form-group mt-0"}
          type="yesno"
          id={"inform" + informMethod}
          label={informMethod === "Sms" ? "Text" : (informMethod === "Telephone"? "Phone call":informMethod)}
          key={informMethod}
          currentValue={this.props.PersonConsent[informMethod]}
          onChange={event =>
            this.updateConsent({
              [informMethod]:
                event.target.value === "true"
                  ? true
                  : event.target.value === "false"
                  ? false
                  : null
            })
          }
          Zebrafied={this.props.Zebrafied}
          UseSlider={this.props.UseSlider}
        />
      );
    });
  }
}
